/**
 * Notistack should be customized by Vapor and should not be
 * modified by the project
 * @param {*} param0
 */

export const onInitService = ({ setContext }) => {
  // const data = getConfig("notistack", {});

  // Try to avoid runtime errors...
  // if (!data.foo) {
  //   throw new Error("should have foo");
  // }

  setContext("notistack", {
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    }
  });
};
